<!-- 城管 -->
<template>
    <MainLayout class="main-layout" :hasLeft="false" :hasRight="hasRight" rightWidth="320px">
        <News slot="header" :hasBack="true" :titleName="$t('home.news.back')" :subtitleName="''" @goBack="
            $router.push({
                path: '/chengguan/index',
            })
            ">
        </News>

        <Middle ref="middle" slot="main" :gridList="gridList" :gridInfo="gridInfo" :photoInfo="photoInfo"
            :eventList="eventList" :mapConfig="mapConfig" :eventInfoId="eventInfoId"
            @getPositionFitVal="getPositionFitVal" @changeSelectTime="changeSelectTime" :queryDate="queryDate" />

        <RightAside slot="right" :queryDate="queryDate" @getEventList="(list) => { eventList = list; }"
            @bindSearch="(id) => { eventInfoId = id; }" @bindTaskImg="getTaskImages" />
    </MainLayout>
</template>

<script>
import * as turf from '@turf/turf';
import { convertArrayToSelectTime } from '@Util';
import utils from '@/page/business/util/map.js';
import MainLayout from '@/components/layout';
import News from '@/page/mainPage/components/news/News.vue';
import RightAside from './components/RightAside.vue';
import Middle from './components/Middle.vue';
import {
    getGridUnitDetail,
    getHistoryFlightImages,
    getLatestFlightImages,
    getSuspiciousEvents,
} from './api/grid.js';

import api from '@/page/DataMessage/api.js';
import girdApi from '@/page/business/chengguan/api/index.js';

import ExifUtil from '@/page/Annotator/util/EXIFUtil.js';

export default {
    components: {
        MainLayout,
        News,
        Middle,
        RightAside,
    },
    props: {},

    data () {
        return {
            eventInfoId: null,
            hasRight: true,
            eventList: [],
            mapConfig: {
                positionFitVal: [],
                positionVal: [],
                mapRange: 0.0008,
            },
            // 网格列表
            gridList: [],

            // 网格信息列表
            gridInfoList: [],

            gridInfo: {
                id: 0,
                code: '',
                name: '',
                description: '',
                gridGroupId: 0,
                geometryText: '',
                altitude: 0,
                cameraZoom: 0,
                row: 0,
                col: 0,
                hasRoute: '',
                siteId: 0,
                teamId: 0,
                areaId: 0,
                status: 0,
                area: 0,
                statusText: '',
                gridWaypointList: [],
            },
            // 格子照片信息配置
            photoInfo: {
                photoList: [],
            },
            queryDate: [],
            routeObj: {},
        };
    },
    watch: {
        '$route.query': {
            handler (newVal) {
                // 获取当前 URL 的查询字符串
                this.routeObj = newVal || { taskId: '', gridId: '', gridGroupId: '' };
                if (this.routeObj.taskId) {
                    let id = this.routeObj.taskId;
                    this.getTaskImages(id);
                }
                if (this.routeObj.gridId) {
                    let id = this.routeObj.gridId;
                    this.getGridUnitDetail(id);
                }
                if (newVal.queryDate) {
                    let arr = JSON.parse(newVal.queryDate);
                    let times = convertArrayToSelectTime(arr);
                    Object.assign(this.queryDate, times);
                }
                this.getGridList();
            },
            immediate: true,
            deep: true,
        },
    },
    computed: {},
    methods: {

        changeSelectTime (times) {
            Object.assign(this.queryDate, times.Lefttimes, times.Righttimes);
            this.queryDate = times;

            this.routeObj.gridGroupId && times.length > 0 && this.getGridGroupStats(this.routeObj.gridGroupId);
        },

        /**
         * 获取网格组单元格统计信息
         */
        getGridGroupStats (gridGroupId) {
            let self = this;
            if (!gridGroupId) return;
            let param = {
                startTime: this.queryDate[0],
                endTime: this.queryDate[1],
                gridGroupId,
            };

            if (!this.validateSearchTime(param)) {
                return;
            }

            girdApi.fetchGridGroupStats(param).then((res) => {
                if (res.code === 200) {
                    let resData = res.data || [];

                    let statsDataMap = {};
                    resData.forEach((item) => {
                        statsDataMap[item.id] = item;
                    });
                    let list = [];
                    this.gridInfoList.forEach((item) => {
                        if (item.gridGroupId === gridGroupId) {
                            list.push(item);
                        }
                    });

                    if (list.length > 0) {
                        list.forEach((item) => {
                            const gridId = item.id;
                            let taskNum = '';
                            let flightNum = '';
                            let eventNum = '';
                            if (statsDataMap[gridId]) {
                                taskNum = statsDataMap[gridId].taskNum || '';
                                flightNum = statsDataMap[gridId].flightNum || '';
                                eventNum = statsDataMap[gridId].eventNum || '';
                            }
                            self.$set(item, 'taskNum', taskNum);
                            self.$set(item, 'flightNum', flightNum);
                            self.$set(item, 'eventNum', eventNum);
                        });
                    }
                    this.gridList = list;
                }
            });
        },

        /**
         * 获取网格列表
         *
         * @returns {Promise<Array>} 返回一个包含任务列表的Promise对象
         */
        getGridList () {
            let param = {};
            girdApi.fetchGridList(param).then((res) => {
                if (res.code === 200) {
                    let list = res.data || [];
                    this.gridInfoList = list[0].gridInfoList;
                    // console.log('网格列表：', this.gridList);
                }
            });
        },

        // 查询网格单元最新飞行图片列表
        async getLatestFlightImages (id) {
            this.photoInfo.photoList = [];
            let ref = await getLatestFlightImages(id);
            if (ref.code === 200) {
                if (ref.data.length > 0) {
                    this.photoInfo.photoList = ref.data;
                }
            } else {
                this.$message.error(ref.msg);
            }
            console.log(' this.photoInfo', this.photoInfo);
        },

        // 获取任务图片列表
        async getTaskImages (id) {
            let params = { taskId: id };
            this.photoInfo.photoList = [];
            await api.getPictureList(params).then((res) => {
                if (res.code === 200 && res.total > 0) {
                    this.photoInfo.photoList = res.rows;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        /**
         * 获取网格单元详细信息
         *
         * @param id 网格单元ID
         * @returns 无返回值
         */
        async getGridUnitDetail (id) {
            let ref = await getGridUnitDetail(id);

            if (ref.code === 200) {
                this.getPositionFitVal(ref.data.geometryText, this.mapConfig.mapRange);
                // console.log(' ref.data.area', ref.data.area);

                let scale = ref.data.area.toString().split('.');

                this.gridInfo = {
                    ...ref.data,
                };
                this.photoInfo = {
                    photoList: [],
                };
                this.getLatestFlightImages(id);
            } else {
                this.$message.error(ref.msg);
            }
        },

        /**
         * 获取地图适配值和中心点坐标
         *
         * @param {string} geometryText - 几何文本，描述多边形或多边形的集合
         * @param {number} range - 范围值，用于调整地图中心点坐标
         */
        getPositionFitVal (geometryText, range) {
            this.hasRight = range !== 0.002;
            let polList = utils.parseMultiPolygon(geometryText, this.getWktType(geometryText));
            let PolygonCoords = utils.closePolygonCoords([polList]);
            let polygon = turf.polygon(PolygonCoords);
            // 计算质心
            let polygonCenter = turf.centroid(polygon);
            let objList1 = [];
            let objList2 = [];
            polList.forEach((item) => {
                objList1.push(item[0]);
                objList2.push(item[1]);
            });

            let maxLng = Math.max.apply(null, objList1);
            let minLng = Math.min.apply(null, objList1);
            let maxLat = Math.max.apply(null, objList2);
            let minLat = Math.min.apply(null, objList2);
            let center = [minLng, minLat - range, maxLng, maxLat + range];
            this.mapConfig.positionFitVal = center;
            this.mapConfig.positionVal = polygonCenter.geometry.coordinates;
        },
        // 解析WKT类型
        getWktType (val) {
            let type = 'Polygon';
            if (val.indexOf('MULTIPOLYGON') > -1) {
                type = 'MULTIPOLYGON';
            } else if (val.indexOf('POLYGON') > -1) {
                type = 'Polygon';
            }
            return type;
        },
        /**
         * 验证搜索时间参数是否合法
         *
         * @param param 参数对象，包含 startTime 和 endTime 属性
         * @returns 如果 startTime 和 endTime 均存在则返回 true，否则返回 false
         */
        validateSearchTime (param) {
            if (!param) return false;
            if (!param.startTime) {
                this.$message.error(this.$t('common.startDateRequired'));
                return false;
            } else if (!param.endTime) {
                this.$message.error(this.$t('common.endDateRequired'));
                return false;
            }
            return true;
        },

        // 获取图片缩放
        getScale (num) {
            const threshold = parseInt(`5${'0'.repeat(num.length)}`, 10);
            let result;
            if (Number(num) >= Number(threshold)) {
                result = 100000;
            } else {
                result = 10000;
            }
            return result;
        },
    },
    mounted () {
        const queryString = this.$route.query;
        this.routeObj = queryString;
        if (this.routeObj.taskId) {
            let id = this.routeObj.taskId;
            this.getTaskImages(id);
        }
        if (this.routeObj.gridId) {
            let id = this.routeObj.gridId;
            this.getGridUnitDetail(id);
        }
        this.getGridList();
    },
};
</script>

<style lang="scss" scoped>
.main-layout {
    height: calc(100% - 16px);
    padding: 0px 8px;
}
</style>
